module.exports = __webpack_public_path__ + "img/f6a2c5b.png";